import React, { useEffect, useRef } from "react";

import { useDataFormContext } from "@/context/FormDataContext";
import { Button, Grid2 } from "@mui/material";
import { Wrapper } from "./styles";

/**
 * @returns ProposalFound component
 */
export default function ProposalFound(): React.JSX.Element {
  const { platformUrl } = useDataFormContext();

  const inputRef = useRef(null) as any;
  useEffect(() => {
    if (inputRef.current) {
      const height = inputRef?.current?.offsetHeight;
      window.parent.postMessage(
        ["setHeight", `${height + (height * 85) / 100}`],
        "*"
      );
    }
  }, []);

  return (
    <div ref={inputRef}>
      <Wrapper>
        <h2>Proposta encontrada!</h2>
        <p>
          <span>
            Acesse a nossa plataforma e venda a sua cota de consórcio hoje
            mesmo!
          </span>
        </p>
      </Wrapper>

      <Grid2 container spacing={3} justifyContent={"center"}>
        <Grid2 size={{ xs: 12, sm: 5 }}>
          <Button
            fullWidth
            variant="goFoward"
            onClick={() =>
              window.open(
                `${platformUrl ? platformUrl : "https://app.consorciei.com.br/"}`,
                "_blank"
              )
            }
          >
            Acessar proposta
          </Button>
        </Grid2>
      </Grid2>
    </div>
  );
}
